const WpBlockEditor = () => {

  /*
  テーブル横スクロール
  */
  const wpBlockTableEls = document.querySelectorAll(".wp-block-table");
  wpBlockTableEls.forEach(wpBlockTableEl => {

    //table-wrapperを作成してtableを囲む
    const tableWrapper = document.createElement("div");
    tableWrapper.className = "table-wrapper";
    wpBlockTableEl.appendChild(tableWrapper);

    //table-wrapperにtableを追加
    const table = wpBlockTableEl.querySelector("table");
    tableWrapper.appendChild(table);
    
    tableWrapper.addEventListener("scroll", (e) => {
      //横スクロールの値が1以上の場合だけクラスを付与
      if (tableWrapper.scrollLeft > 1) {
        wpBlockTableEl.classList.add("is-scroll");
      } else {
        wpBlockTableEl.classList.remove("is-scroll");
      }
    });
  });
};

export default WpBlockEditor;